// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"864e84d6","667":"c6e6963f"}[chunkId] + ".chunk.js";
};